import { fetchApi } from '@/services/api-client';

export const AWARD_CATEGORIES_PATH = '/admin/award-categories';

export type AwardCategory = {
  id: string;
  name: string;
  color: string | null;
  icon: string | null;
  sortOrder: number;
  active: boolean;
  createdAt: string;
  updatedAt: string;
};

export const awardCategoriesApi = {
  list: () => fetchApi<AwardCategory[]>(AWARD_CATEGORIES_PATH),
  getById: (id: string) => fetchApi<AwardCategory>(`${AWARD_CATEGORIES_PATH}/${id}`),
  create: (data: { name: string; color?: string; icon?: string; sortOrder?: number; active?: boolean }) =>
    fetchApi<AwardCategory>(AWARD_CATEGORIES_PATH, { method: 'POST', body: JSON.stringify(data) }),
  update: (
    id: string,
    data: { name?: string; color?: string | null; icon?: string | null; sortOrder?: number; active?: boolean }
  ) =>
    fetchApi<AwardCategory>(`${AWARD_CATEGORIES_PATH}/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    }),
  delete: (id: string) => fetchApi<{ success: boolean }>(`${AWARD_CATEGORIES_PATH}/${id}`, { method: 'DELETE' }),
};
